export const availableChatResponseTypes = {
    trial_experience_card: "trial_experience_card",
    rfi_comparison_card: "rfi_comparison_card",
    rfi_download_card: "rfi_download_card",
    vendor_profile_discovery_card: "vendor_profile_discovery_card"
}

export function formatTimeAgo(timestamp) {
    const now = new Date();

    if (typeof timestamp === "string" && timestamp.includes("ago")) {
        return timestamp;
    }

    const date = new Date(timestamp);

    if(isNaN(date.getTime())) {
        return "";
    }

    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 45) {
        return "just now";
    } else if (seconds < 90) {
        return "a minute ago";
    } else if (seconds < 60 * 45) {
        return Math.round(seconds / 60) + " minutes ago";
    } else if (seconds < 60 * 90) {
        return "an hour ago";
    } else if (seconds < 60 * 60 * 24) {
        return Math.round(seconds / (60 * 60)) + " hours ago";
    } else if (seconds < 60 * 60 * 24 * 30) {
        return Math.round(seconds / (60 * 60 * 24)) + " days ago";
    } else if (seconds < 60 * 60 * 24 * 365) {
        return Math.round(seconds / (60 * 60 * 24 * 30)) + " months ago";
    } else {
        return Math.round(seconds / (60 * 60 * 24 * 365)) + " years ago";
    }
}